/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-05-15",
    versionChannel: "nightly",
    buildDate: "2024-05-15T00:05:28.113Z",
    commitHash: "b5948a883a7ca22306cfb67ebd1d6a257abb304e",
};
